import React, { ElementType } from 'react';
import generatePreviewUrl from '../../utils/generatePreviewUrl';
import { filterI18nProps } from '../../utils/styledComponentsUtils';

interface IProps {
  id?: string,
  src: string | null,
  alt?: string
}

/* The legacy urls can be of the following forms:
    - http://central.xosvault.com/repository/resource?uuid={uuid}
    - http://central.xosvault.com/repository/thumbnail?uuid={uuid} */
const LEGACY_URL_REGEX = 'http://central.xosvault.com/repository/[a-zA-Z0-9]+\\?uuid=';
const URL_SPLIT_REGEX = new RegExp('[=/?&]', 'g');

function proxyImageUrl(props: IProps): string | null {
  const { src } = props;

  // If the url matches the legacy format, replace it with the vault 2 API proxy endpoint
  if (src && src.match(LEGACY_URL_REGEX)) {
    const parts = src.split(URL_SPLIT_REGEX);
    const uuid = parts[6];
    return generatePreviewUrl(uuid);
  }

  return src;
}

function vaultImageProxy(ImgComponent: ElementType): ElementType {
  return (props: IProps) => {
    const imageUrl = proxyImageUrl(props);
    return <ImgComponent {...filterI18nProps(props)} src={imageUrl} />;
  };
}

export default vaultImageProxy;
